// extracted by mini-css-extract-plugin
export default {"hidden":"CategorySearchAccordionWrapper_hidden__pzSAG","shown":"CategorySearchAccordionWrapper_shown__sSpIQ"};